export default "__VITE_ASSET__960b058d__"